import {
  
  Edit,
  Trash2
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import { useCheckUserPermission } from "../../common/userPermission";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import HeaderModule from "../../components/Header/HeaderModule";
import { dateFormat } from "../../common/common";

const customerDelete = "customerDelete";

const CustomerList = () => {
  const user_data = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  
  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoadingAlert(); // Show loader while deleting
        handleDelete(id);
      }
    });
  };
  
  const showLoadingAlert = () => {
    MySwal.fire({
      title: "Deleting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        MySwal.showLoading(); // Show loading spinner
      },
    });
  };
  
  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "customer",
    };
  
    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });
  
      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your customer has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
        prodcutDataListApi()
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

     const formatDBPhoneNumber = (number) => {
  if (!number) return "";

  let cleaned = number.replace(/\D/g, ""); // remove non-digits
  if (cleaned.startsWith("61")) {
    cleaned = "+" + cleaned;
  } else if (cleaned.startsWith("0")) {
    cleaned = "+61" + cleaned.substring(1);
  } else if (!cleaned.startsWith("+61")) {
    cleaned = "+61" + cleaned;
  }

  const noPlus = cleaned.replace("+", "");

  return (
    "+" +
    noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3")
  );
};
  
  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
    },
    {
      header: "First Name",
      accessorKey: "firstName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Last Name",
      accessorKey: "lastName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Email",
      accessorKey: "email",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Phone",
      accessorKey: "phoneNumber",
      enableSorting: true,
      sortingFn: "alphanumeric",
       Cell: ({ cell }) => formatDBPhoneNumber(cell.getValue())
    },
    {
      header: "Birth Date",
      accessorKey: "birthDate",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell : ({row}) => <span>{dateFormat(row.original.birthDate)}</span>
    },
    {
      header: "Gender",
      accessorKey: "gender",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.25rem",
          }}
        >
          <span>{dateFormat(row.original.createdAt)}</span>
        </div>
      ),
    },
    {
      header: "Status",
      accessorKey: "isActive",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
        <span
          className={
            row.original.isActive === 1 ? "btn btn-primary btn-sm me-2" : "btn btn-outline-primary btn-sm me-2"
          }
        >
          {row.original.isActive === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      header: "Source",
      accessorKey: "source",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(route.customer) && (
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="primary"
            onClick={() => {
              navigate(`${route.customer}/${row.original.id}`);
              console.log("Edit row:", row.original.id);
            }}
          >
            <Edit className='custome-icon-size' />
          </button>
          )}
          {useCheckUserPermission(customerDelete) && (
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              showConfirmationAlert(row.original.id);
            }}
          >
            <Trash2 className='custome-icon-size' />
          </button>
          )}
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    setLoading(true);
    const response = await apiHandler({
      method: "GET",
      route: `Business/customerlist?businessId=${user_data?.businessId || 0}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
      setLoading(false);
    } else {
      console.log(response, "data");
      setLoading(false);
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  
  const exportData = productlist.map((item) => ({
    ID: item?.id,
    BusinessName: item?.firstName,
    Question: item?.lastName,
    Answer: item?.answer,
  }));

  return (
    <>
    <LoadingSpinner isLoading={loading} />
    <div className="page-wrapper">
      <div className="content">
          <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.customer}
          showImport={true}
        />
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} columnRightPin={['actions']}/>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default CustomerList;
